import React from 'react';
import { connect } from 'react-redux';
import { HeaderText, Button } from '@el8/vital';
import { Card, Box } from 'components';
import { Dispatch, HydratedPatientInfo, State } from 'types';
import { getActivePatient } from 'modules/patient';
import { updateSession } from 'modules/session';
import { getFullNameFromPatientChart } from 'utils/patient';

import styles from './ChartSelection.less';

type StateProps = {
  activeChartId: number;
  activePatient: HydratedPatientInfo;
};

type DispatchProps = {
  selectChart: (chartId: number) => void;
};

type OwnProps = {
  addNewPatient?: () => void;
  title?: string;
};

type Props = StateProps & DispatchProps & OwnProps;

const mapStateToProps = (state: State): StateProps => ({
  activePatient: getActivePatient(state),
  activeChartId: state.session.activeChartId,
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  selectChart: (chartId): void => {
    dispatch(updateSession({ activeChartId: chartId }));
  },
});

const ChartSelection: React.FC<Props> = ({
  activeChartId,
  activePatient,
  addNewPatient,
  selectChart,
  title = 'Select patient',
}) => {
  if (!activePatient) return null;

  return (
    <Card>
      <HeaderText align="center" legacyVariant="legacyTitleText" sizing="heading-lg" tag="h1">
        {title}
      </HeaderText>
      <Box className={styles.form} direction="column">
        {activePatient.charts.map(
          (chart): JSX.Element => (
            <Button
              key={chart.id}
              kind={activeChartId === chart.id ? 'primary' : 'default'}
              className={styles.patient}
              appearance={activeChartId === chart.id ? 'default' : 'outline'}
              onClick={(): void => selectChart(chart.id)}
            >
              {getFullNameFromPatientChart(chart)}
              <div className={styles.patientDob}>{chart.dob}</div>
            </Button>
          ),
        )}
        {addNewPatient && (
          <Button
            appearance="outline"
            className={styles.newPatient}
            onClick={addNewPatient}
            iconName="add"
          >
            Add New Patient
          </Button>
        )}
      </Box>
    </Card>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ChartSelection);
